import React, { useEffect, useRef, useState } from 'react';
import Pesquisar from '../Pesquisar';
import { Button, Card, Spin } from 'antd';
import '../TelaVendas.css'; // Assumindo que os estilos foram movidos para um arquivo CSS
import ModalItemSelecionado from '../ModalItemSelecionado';
import FinalizarOrcamento from './FinalizarOrcamento';
import LeitorQRCode from '../LeitorQRCode';
import BuscarOrcamentos from './BuscarOrcamentos';
import axios from 'axios';
import { api } from '../../../../config/api';
import { formatarQuantidade } from '../../../../utils/formatters';
import { useConfigQuery } from '../../../../queries/useConfig';
import axiosInstance from '../../../../axiosInterceptor';
import BuscarDelivery from '../BuscarDelivery';

const Orcamentos = ({ tipoTela, produtos, setProdutos, pagamentoConcluido, setPagamentoConcluido, pagamentos, setPagamentos, consumidorIdentificado, setConsumidorIdentificado, consumidor, setConsumidor, pagItem, setPagItem }) => {
  const [vendaPuxada, setVendaPuxada] = useState(false);
  const [isBuscarOrcamento, setIsBuscarOrcamento] = useState(false);
  const [isPesquisar, setIsPesquisar] = useState(false);
  const [isFinalizarOrcamento, setIsFinalizarOrcamento] = useState(false);
  const [acresDescFreteConcluido, setAcresDescFreteConcluido] = useState(false);
  const [quantidadeDeItens, setQuantidadeDeItens] = useState(0);
  const [precoTotal, setPrecoTotal] = useState(0);
  const [totalSemFrete, setTotalSemFrete] = useState(0);
  const [totalDescontos, setTotalDescontos] = useState(0);
  const [totalAcrescimos, setTotalAcrescimos] = useState(0);
  const [travarAcrescimoDescFrete, setTravarAcrescimoDescFrete] = useState(false);
  const [subTotal, setSubtotal] = useState(0);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [isLoading, setIsLoading] = useState(false);
  const [nomeCupom, setNomeCupom] = useState('');
  const [documentoCupom, setDocumentoCupom] = useState('');
  const [tokenPedidoTechsapp, setTokenPedidoTechsapp] = useState(null);
  const [consumidorIntegrado, setConsumidorIntegrado] = useState(null);
  const [numeroEvento, setnumeroEvento] = useState('');
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [isLerCodigo, setIsLerCodigo] = useState(false);
  const [idOrcamento, setIdOrcamento] = useState('');
  const [cardAberto, setCardAberto] = useState('');
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [restauranteId, setRestauranteId] = useState('');
  const inputRef = useRef(null);
  const [mensagem, setMensagem] = useState('');
  const [idVendedorOrcamento, setIdVendedorOrcamento] = useState(null);
  const { data: config, error } = useConfigQuery();
  const [idPedidoMkt, setIdPedidoMkt] = useState("");
  const [totalProdutos, setTotalProdutos] = useState(0);
  const [quantidadeProdutos, setQuantidadeProdutos] = useState(0);
  const [mensagemTela, setMensagemTela] = useState('');
  const [totalServicos, setTotalServicos] = useState(0);
  const [isFinalizarVenda, setIsFinalizarVenda] = useState(false);
  const [quantidadeServicos, setQuantidadeServicos] = useState(0);
  const [terminal, setTerminal] = useState(1);
  const [isBuscarDelivery, setIsBuscarDelivery] = useState(false);
  const [acresDescFrete, setAcresDescFrete] = useState({
    acresTotal: '0',
    descTotal: '0',
    frete: '0',
  });
  const handleVoltarBuscarDeliveryClick = () => {
    setIsBuscarDelivery(false); // Voltar para a tela de vendas
  };


  const tratarProdutoBuscadoPorEan = item => {
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  const tratarProdutoBuscadoPorCodigoDeBalanca = item => {
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const valor = e.target.value.trim();
      if (valor) {
        buscarProdutoPorCodigoBarras(valor);
        e.target.value = ''; // limpa o campo
        inputRef.current.focus(); // volta o foco
      }
    }
  };

  const toNumber = (v) => {
    if (v == null) return NaN;
    const s = String(v).trim().replace(',', '.').replace(/[^\d.]/g, '');
    return Number(s);
  };

  const extrairCodigoParaBusca = (codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    if (cb.includes('$')) {
      const [, codigo] = cb.split('$');   // pega depois do $
      return String(codigo || '').trim();
    }

    if (cb.includes('*')) {
      const [, codigo] = cb.split('*');   // pega depois do *
      return String(codigo || '').trim();
    }

    return cb;
  };

  const tratarProdutoQuantidadeValor = (item, codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    // defaults
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;

    // "*" => 40*12  => quantidade=40, preco = preco*40
    if (cb.includes('*')) {
      const [qStr] = cb.split('*');
      const q = toNumber(qStr);

      if (Number.isFinite(q) && q > 0) {
        item.quantidade = q;
      }

      // "$" => 40$12  => 40 é valor total, 12 é só o código; qtd = total / precoUnit
    } else if (cb.includes('$')) {
      const [totalStr] = cb.split('$'); // ignora o "12" (código)
      const total = toNumber(totalStr);

      const precoUnit = toNumber(item.preco); // preço unitário do produto já buscado
      if (Number.isFinite(total) && total > 0 && Number.isFinite(precoUnit) && precoUnit > 0) {
        item.quantidade = total / precoUnit;

        // se quiser limitar casas (ex.: 3) para não ficar infinito:
        // item.quantidade = Number((total / precoUnit).toFixed(3));
      }
    }

    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  const buscarProdutoPorCodigoBarras = async (codigoBarras) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };

      let response = {};
      let codigoDeBalanca = false;
      if (codigoBarras !== '') {
        if (codigoBarras.startsWith("2")) {
          console.log("O código de barras começa com 2");
          codigoDeBalanca = true;

        }

        const codigoParaBusca = extrairCodigoParaBusca(codigoBarras);

        setMensagem(`🔍 Procurando o código de barras: ${codigoBarras}`);


        let startEan2 = Number(config?.terminalComercial?.startEan2);
        let endEan2 = Number(config?.terminalComercial?.endEan2);

        if (
          !Number.isInteger(startEan2) ||
          !Number.isInteger(endEan2) ||
          startEan2 < 1 ||
          startEan2 > 6 ||
          endEan2 < 1 ||
          endEan2 > 6 ||
          startEan2 > endEan2
        ) {
          startEan2 = 1;
          endEan2 = 6;
        }

        response = await axios.get(
          `${api.techspdv}/v1/restaurantes/${restauranteId}/produtos/buscarporeanCodigoBalanca/${codigoParaBusca}/${startEan2}/${endEan2}`,
          options
        );

        console.log(response.data);
        if (response.data && response.status == 200) {
          if (codigoDeBalanca) {
            console.log(response.data.quantidade);
            console.log(response.data.valorAferido);
            console.log(response.data.preco);

            const { valorAferido, preco } = response.data;

            if (
              typeof valorAferido === 'number' &&
              typeof preco === 'number' &&
              preco !== 0
            ) {
              response.data.quantidade = (valorAferido / preco).toFixed(3);
            } else {
              response.data.quantidade = "0.000";
            }


            tratarProdutoBuscadoPorCodigoDeBalanca(response.data);

          } else {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
          }
          setMensagem(``);
        } else {

          response = await axios.get(
            `${api.techspdv}/v1/restaurantes/${restauranteId}/produtos/buscarporcod/${codigoParaBusca}`,
            options
          );

          if (response.data && response.status == 200) {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
            setMensagem(``);
          }

          if (response.status != 200) {
            setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
          }


        }

      }
    } catch (error) {
      console.error('Erro ao buscar produto por EAN:', error);
      if (error.status == 404) {
        setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
      }

    }

  };

  function temPrecoZeradoOuNulo(produtos) {
    return produtos.some(produto => produto.preco === 0 || produto.preco === null);
  }

  const mostrarCertificado =
    Array.isArray(config?.certificado?.Documentos) &&
    config.certificado.Documentos.length > 0 &&
    config.certificado.Documentos[0]?.CertDiasValido <= 30;

  const CardResumoVendas = ({
    mensagemCertificado,
    mostrarCertificado,
    onRenovarCertificado,
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        width: '100%',
        minHeight: '64px',
        padding: '10px 14px',
        backgroundColor: '#ffffff',
        border: '1px solid #e8e8e8',
        borderRadius: '12px',
        boxShadow: '0 3px 12px rgba(0, 0, 0, 0.035)',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '46px',
          height: '46px',
          minWidth: '46px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0ecff',
          fontSize: '23px',
        }}
      >
        🖥️
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          flex: 1,
          minWidth: 0,
        }}
      >
        <strong
          style={{
            color: '#111',
            fontSize: '24px',
            lineHeight: 1.2,
          }}
        >
          {tipoTela}
        </strong>

        {mostrarCertificado && (
          <Button
            danger
            size="small"
            onClick={onRenovarCertificado}
            style={{
              width: 'fit-content',
              maxWidth: '100%',
              marginTop: '6px',
              fontSize: '12px',
              whiteSpace: 'normal',
              height: 'auto',
              lineHeight: 1.3,
              padding: '4px 10px',
              backgroundColor: 'red',
              color: '#fff'
            }}
          >
            {mensagemCertificado}
          </Button>
        )}
      </div>
    </div>
  );
  const CardResumo = ({
    icone,
    titulo,
    valor,
    descricao,
    cor = '#1677ff',
    fundoIcone = '#eaf3ff',
    destaque = false,
    children,
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        backgroundColor: '#ffffff',
        border: destaque
          ? `1px solid ${cor}`
          : '1px solid #e8e8e8',
        borderRadius: '12px',
        padding: '10px 14px',
        minHeight: '64px',
        boxShadow: destaque
          ? `0 4px 14px ${cor}20`
          : '0 3px 12px rgba(0, 0, 0, 0.035)',
      }}
    >
      <div
        style={{
          width: '46px',
          height: '46px',
          minWidth: '46px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: fundoIcone,
          fontSize: '23px',
        }}
      >
        {icone}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <span
          style={{
            color: '#777',
            fontSize: '13px',
            marginBottom: '3px',
          }}
        >
          {titulo}
        </span>

        <strong
          style={{
            color: destaque ? cor : '#111',
            fontSize: destaque ? '22px' : '18px',
            lineHeight: 1.2,
          }}
        >
          {valor}
        </strong>

        {descricao && (
          <span
            style={{
              color: '#999',
              fontSize: '12px',
              marginTop: '3px',
            }}
          >
            {descricao}
          </span>
        )}
      </div>
    </div>
  );
  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`${api.techfood}/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (restauranteId) {
      axios
        .get(
          `${api.techspdv}/v1/restaurantes/${restauranteId}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(options);
        });
    }
  }, [restauranteId]);


  const [recalcular, setRecalcular] = useState(false);


  const handlePesquisarClick = () => {
    setIsPesquisar(true); // Mostrar a tela de pesquisa
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleVoltarClick = () => {
    setIsPesquisar(false);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };
  const focarCodigoDeBarras = () => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const trataProdutos = produto => {
    setProdutos([...produtos, produto]);

  };


  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const CalcularTotais = () => {
    let quantidadeDeItensAux = 0;
    let precoTotalAux = 0;
    let totalSemFreteAux = 0;
    let subTotalAux = 0;
    let totalDescontosAux = 0;
    let totalAcrescimosAux = 0;

    // Novos totais separados
    let totalProdutosAux = 0;
    let quantidadeProdutosAux = 0;

    let totalServicosAux = 0;
    let quantidadeServicosAux = 0;

    produtos.forEach(produto => {
      console.log(produto);

      const quantidade = Number(produto.quantidade || 0);
      const preco = Number(produto.preco || 0);
      const valorDesconto = Number(produto.valorDesconto || 0);
      const valorAcrescimo = Number(produto.valorAcrescimo || 0);
      const frete = Number(produto.frete || 0);

      /*
       * Mantém exatamente a mesma lógica usada atualmente
       * no total sem frete.
       */
      const totalItemSemFrete =
        preco * quantidade -
        valorDesconto +
        valorAcrescimo;

      quantidadeDeItensAux += quantidade;

      subTotalAux += preco * quantidade;

      totalSemFreteAux += totalItemSemFrete;

      precoTotalAux +=
        totalItemSemFrete +
        frete;

      totalDescontosAux += valorDesconto;
      totalAcrescimosAux += valorAcrescimo;

      /*
       * ntipoItem 5 = serviço.
       * Todos os demais tipos continuam sendo tratados como produto.
       */
      const ehServico = Number(produto.ntipoItem) === 5;

      if (ehServico) {
        quantidadeServicosAux += quantidade;
        totalServicosAux += totalItemSemFrete;
      } else {
        quantidadeProdutosAux += quantidade;
        totalProdutosAux += totalItemSemFrete;
      }
    });

    // Totais que já existiam
    setQuantidadeDeItens(quantidadeDeItensAux);
    setPrecoTotal(precoTotalAux);
    setTotalSemFrete(totalSemFreteAux);
    setSubtotal(subTotalAux);
    setTotalDescontos(totalDescontosAux);
    setTotalAcrescimos(totalAcrescimosAux);

    // Novos totais separados
    setQuantidadeProdutos(quantidadeProdutosAux);
    setTotalProdutos(Number(totalProdutosAux.toFixed(2)));

    setQuantidadeServicos(quantidadeServicosAux);
    setTotalServicos(Number(totalServicosAux.toFixed(2)));
  };


  const openModalItem = produto => {
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };
  useEffect(() => {
    CalcularTotais();
  }, [produtos, recalcular]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9' }}>
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '18px',
          borderRadius: '16px',
          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
          border: '1px solid #eeeeee',
          width: '100%'
        }}
      >
        {/* Data, terminal e operador */}
        <div
          style={{
            display: 'grid',
            width: '100%',              // <- adicionar
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: '12px',
            marginBottom: '12px',
            alignItems: 'stretch',      // <- adicionar
          }}
        >
          <CardResumoVendas
            mostrarCertificado={mostrarCertificado}
            mensagemCertificado={config?.mensagemCertificado}
            onRenovarCertificado={async (e) => {
              e.stopPropagation();

              window.open(
                'https://seucertificadodigital.com/loja/?p=u49-tech-union',
                '_blank'
              );

              const options = {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${accessToken}`,
                },
              };

              try {
                await axiosInstance.get(
                  `${api.technfe}/v1/enviarEmailRenovarCertificado/${config?.restaurante?.nome}`,
                  options
                );
              } catch (error) {
                console.error(
                  'Erro ao enviar e-mail de renovação do certificado:',
                  error
                );
              }
            }}
          />
          <CardResumo
            icone="👤"
            titulo="Operador"
            valor={operador || 'Não informado'}
            descricao=""
            cor="#00a86b"
            fundoIcone="#e8f8f1"
          />


          <CardResumo
            icone="⌨️"
            titulo="Terminal"
            valor={terminal || '1'}
            descricao=""
            cor="#1677ff"
            fundoIcone="#eaf3ff"
          />
          <CardResumo
            icone="📅"
            titulo="Data"
            valor={getDataAtual()}
            descricao=""
            cor="#6c4cff"
            fundoIcone="#f0ecff"
          />

        </div>
      </div>


      {
        isBuscarOrcamento ? (
          <BuscarOrcamentos
            closeModal={() => {
              setIsBuscarOrcamento(false);
              focarCodigoDeBarras();
            }}
            tratarProdutosOrcamento={orcamento => {
              setIsLoading(true);
              setVendaPuxada(true);
              setIdVendedorOrcamento(orcamento.idVendedor);
              function validarDocumento(documento) {
                // Remover caracteres não numéricos
                documento = documento.replace(/[^\d]+/g, '');

                // Verificar se o documento é um CPF
                if (documento.length === 11) {
                  let cpf = documento;
                  let add = 0;
                  for (let i = 0; i < 9; i++) {
                    add += parseInt(cpf.charAt(i)) * (10 - i);
                  }
                  let rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(9))) return false;

                  add = 0;
                  for (let i = 0; i < 10; i++) {
                    add += parseInt(cpf.charAt(i)) * (11 - i);
                  }
                  rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(10))) return false;

                  return true;
                }

                // Verificar se o documento é um CNPJ
                else if (documento.length === 14) {
                  let cnpj = documento;
                  let tamanho = cnpj.length - 2;
                  let numeros = cnpj.substring(0, tamanho);
                  let digitos = cnpj.substring(tamanho);
                  let soma = 0;
                  let pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(0))) return false;

                  tamanho = tamanho + 1;
                  numeros = cnpj.substring(0, tamanho);
                  soma = 0;
                  pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(1))) return false;

                  return true;
                }

                // Se não for nem CPF nem CNPJ, retorna false
                else {
                  return false;
                }
              }
              if (validarDocumento(orcamento.cpf)) {
                console.log('Cpf valido');
                if (accessToken) {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };

                  axios
                    .get(
                      `${api.techspdv}/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                      options,
                    )
                    .then(consumidorResp => {
                      console.log(
                        `${api.techspdv}/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                      );

                      if (consumidorResp) {
                        console.log(consumidorResp.data);
                        if (consumidorResp.data) {
                          setConsumidor(consumidorResp.data);
                          setConsumidorIdentificado(true);
                        }
                      }
                    })
                }
              }



              if (produtos.length == 0) {
                const pagamentosAux = [];
                orcamento.pagamentos.map(pagamento => {

                  const novoPagamento = {
                    tipo: pagamento.codigoFiscal,
                    tipoNome: pagamento.descricao,
                    valor: pagamento.valor,
                  }
                  pagamentosAux.push(novoPagamento);

                })
                console.log('Pagamentos');
                console.log(pagamentosAux);
                setPagamentos(pagamentosAux);



                let pagItemAux = new Array();
                pagamentosAux.map(pagamento => {
                  const pagamentoFormatado = {
                    tPag: pagamento.tipo,
                    vPag: pagamento.valor.toFixed(2),
                    xPag: pagamento.tipoNome,
                  };
                  pagItemAux.push(pagamentoFormatado);
                });
                setPagItem(pagItemAux);

                setPagamentoConcluido(true);
              }
              console.log('orcamento');
              console.log(JSON.parse(orcamento.jsonDocFiscal).det.detItem);

              // pegue e normalize o detItem
              const detItems = JSON.parse(orcamento.jsonDocFiscal)?.det?.detItem;
              const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

              // índice por cProd (chave como string para evitar problemas de tipo)
              const detByCProd = new Map(
                detArray.map(it => [String(it?.prod?.cProd), it])
              );

              detArray.map(async item => {
                console.log(item);

                const produto = item?.prod;
                try {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };

                  const response = await axios.get(
                    `${api.techspdv}/v1/restaurantes/${orcamento.idEmpresa
                    }/produtos/${produto.cProd}?page=${0}`,
                    options,
                  );

                  const produtosAux = produtos;
                  if (response.data) {
                    console.log(response.data);

                    response.data.preco = produto.vUnCom;
                    response.data.quantidade = produto.qCOM;
                    response.data.acrescimo = produto.vOutro_item;
                    response.data.desconto = produto.vDesc;
                    response.data.valorAcrescimo = produto.vOutro_item;
                    response.data.valorDesconto = produto.vDesc;
                    response.data.frete = produto.vFrete ? produto.vFrete : 0;
                    response.data.observacao = produto.observacao || '';
                    response.data.idVendedor = produto.idVendedor || '';
                    console.log(response.data);
                    produtosAux.push(response.data);
                    CalcularTotais();
                  }

                  setProdutos(produtosAux);
                } catch (error) {
                  setIsLoading(false);
                  setVendaPuxada(false);
                  console.error('Erro ao fazer a requisição:', error);
                }
              })




              setIdOrcamento(orcamento.id);

              let acresDescFreteAux = acresDescFrete;
              acresDescFreteAux.frete = orcamento.valorFrete;
              setAcresDescFrete(acresDescFreteAux);
              console.log('orcamento');
              console.log('orcamento');
              console.log(orcamento);
              console.log('produtos');
              console.log(produtos);


              setIsLoading(false);

            }}
          />

        ) :
          isPesquisar ? (
            <Pesquisar
              onItemPress={trataProdutos}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagamentos={setPagamentos}
              closeModal={handleVoltarClick}
              validarEstoque={false}
            ></Pesquisar>
          ) : isLerCodigo ? (
            <LeitorQRCode />
          ) : isBuscarDelivery ? (
            <BuscarDelivery
              onItemPress={trataProdutos}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagamentos={setPagamentos}
              closeModal={() => { handleVoltarBuscarDeliveryClick(); focarCodigoDeBarras(); }}
              setAcresDescFrete={setAcresDescFrete}
              acresDescFrete={acresDescFrete}
              setTravarAcrescimoDescFrete={setTravarAcrescimoDescFrete}
              setDocumentoCupom={setDocumentoCupom}
              setNomeCupom={setNomeCupom}
              consumidorIntegrado={consumidorIntegrado}
              setConsumidorIntegrado={setConsumidorIntegrado}
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              setTokenPedidoTechsapp={setTokenPedidoTechsapp}
              setVendaPuxada={setVendaPuxada}
              setMensagemTela={setMensagemTela}

            ></BuscarDelivery>
          ) :
            isFinalizarOrcamento ? (<FinalizarOrcamento
              closeModal={() => { setIsFinalizarOrcamento(false) }}
              onItemPress={trataProdutos}
              setConsumidorIdentificado={setConsumidorIdentificado}
              consumidorIdentificado={consumidorIdentificado}
              nomeCupom={nomeCupom}
              documentoCupom={documentoCupom}
              setNomeCupom={setNomeCupom}
              setDocumentoCupom={setDocumentoCupom}
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              precoTotal={precoTotal}
              pagamentoConcluido={pagamentoConcluido}
              setPagamentoConcluido={setPagamentoConcluido}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              produtos={produtos}
              setProdutos={setProdutos}
              subTotal={subTotal}
              CalcularTotais={CalcularTotais}
              acresDescFrete={acresDescFrete}
              setAcresDescFrete={setAcresDescFrete}
              totalDescontos={totalDescontos}
              totalAcrescimos={totalAcrescimos}
              acresDescFreteConcluido={acresDescFreteConcluido}
              setAcresDescFreteConcluido={setAcresDescFreteConcluido}
              setPagItem={setPagItem}
              pagItem={pagItem}
              formasDePagamento={formasDePagamento}
              idVendedorOrcamento={idVendedorOrcamento}
              idOrcamento={idOrcamento}
              setVendaPuxada={setVendaPuxada}
              focarCodigoDeBarras={focarCodigoDeBarras}
              tipoTela={tipoTela}
            ></FinalizarOrcamento>) : (
              isModalVisibleItem ? (
                <ModalItemSelecionado
                  isVisible={isModalVisibleItem}
                  onClose={() => setModalVisibleItem(false)}
                  onSave={updatedProduto => {
                    console.log(updatedProduto);
                    produtos[updatedProduto.index] = updatedProduto;
                    //produto = updatedProduto;
                    setRecalcular(!recalcular);
                    setPagamentoConcluido(false);
                    setPagamentos([]);
                  }}
                  onDelete={item => {
                    produtos.splice(item.index, 1);
                    setRecalcular(!recalcular);
                    setPagamentoConcluido(false);
                    setPagamentos([]);
                  }}
                  produto={selectedProduto}
                />
              ) : (
                // Caso contrário, exibe a tela de vendas
                <div>
                  <div style={{ display: 'flex', marginBottom: '20px', gap: '10px' }}>
                    <button
                      onClick={handlePesquisarClick}
                      style={{
                        flex: 1,
                        marginRight: '10px',
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                        cursor: idPedidoMkt ? 'not-allowed' : 'pointer',
                      }}

                      disabled={idPedidoMkt}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>🔍</span>
                      Pesquisar Produto
                    </button>

                    <button
                      style={{
                        flex: 1,
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                        cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                      }}
                      disabled={vendaPuxada}
                      onClick={() => {
                        setIsBuscarOrcamento(true);
                      }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                      Buscar Orçamento
                    </button>

                    <button
                      style={{
                        flex: 1,
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                        cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                      }}
                      disabled={vendaPuxada}
                      onClick={() => {
                        setMensagemTela('Aguarde processamento dos itens do Pedido...');
                        setIsBuscarDelivery(true);
                      }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>🏍️</span>
                      Buscar Delivery
                    </button>

                    <button
                      style={{
                        flex: 1,
                        backgroundColor: '#90ee90',
                        color: '#000',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (produtos.length > 0 && !temPrecoZeradoOuNulo(produtos)) {
                          setIsFinalizarOrcamento(true);
                        } else {
                          window.alert(
                            produtos.length === 0
                              ? 'Adicione produtos à compra!'
                              : 'Existem produtos com preço zerado ou inválido!'
                          );
                        }
                      }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
                      Finalizar Venda
                    </button>
                  </div>



                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      padding: '18px',
                      borderRadius: '16px',
                      boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
                      border: '1px solid #eeeeee',
                    }}
                  >


                    {/* Quantidades e valores na mesma linha */}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
                        gap: '10px',
                        marginBottom: '14px',
                      }}
                    >

                      <CardResumo
                        icone="📦"
                        titulo="Valor Produtos"
                        valor={Number(totalProdutos || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                        descricao=""
                        cor="#1677ff"
                        fundoIcone="#eaf3ff"
                      />

                      <CardResumo
                        icone="📦"
                        titulo="Qtd Produtos"
                        valor={formatarQuantidade(quantidadeProdutos || 0)}
                        descricao=""
                        cor="#1677ff"
                        fundoIcone="#eaf3ff"
                      />


                      <CardResumo
                        icone="⭐"
                        titulo="Valor Serviços"
                        valor={Number(totalServicos || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                        descricao=""
                        cor="#00a86b"
                        fundoIcone="#e8f8f1"
                      />
                      <CardResumo
                        icone="🛎️"
                        titulo="Qtd Serviços"
                        valor={formatarQuantidade(quantidadeServicos || 0)}
                        descricao=""
                        cor="#00a86b"
                        fundoIcone="#e8f8f1"
                      />
                      <CardResumo
                        icone="🛍️"
                        titulo="Qtd Total"
                        valor={formatarQuantidade(quantidadeDeItens || 0)}
                        descricao=""
                        cor="#f59e0b"
                        fundoIcone="#fff4dc"
                      />

                      <CardResumo
                        icone="💰"
                        titulo="Valor Total"
                        valor={Number(totalSemFrete || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                        descricao=""
                        cor="#6c4cff"
                        fundoIcone="#f0ecff"
                        destaque
                      />


                    </div>

                    {/* Código de barras */}
                    <div
                      style={{
                        background:
                          'linear-gradient(135deg, hsl(240, 1%, 46%) 0%, #1f1f1f 100%)',
                        border: '1px solid #8b6cff',
                        borderRadius: '12px',
                        padding: '12px 16px',
                      }}
                    >


                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            maxWidth: '620px',
                            display: 'flex',
                            alignItems: 'stretch',
                          }}
                        >
                          <div
                            style={{
                              width: '48px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#f4f4f6',
                              border: '1px solid #d9d9d9',
                              borderRight: 'none',
                              borderRadius: '8px 0 0 8px',
                              fontSize: '20px',
                            }}
                          >
                            ▥
                          </div>

                          <input
                            ref={inputRef}
                            type="text"
                            placeholder="Digite ou leia o código de barras"
                            disabled={Boolean(idPedidoMkt)}
                            onKeyDown={handleKeyDown}
                            style={{
                              flex: 1,
                              minWidth: 0,
                              padding: '11px 14px',
                              border: '1px solid #d9d9d9',
                              borderRadius: '0 8px 8px 0',
                              fontSize: '14px',
                              textAlign: 'center',
                              outline: 'none',
                              backgroundColor: idPedidoMkt
                                ? '#f0f0f0'
                                : '#ffffff',
                            }}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          display: 'block',
                          textAlign: 'center',
                          color: '#fff',
                          fontSize: '14px',
                          marginTop: '6px',
                        }}
                      >
                        Pressione ENTER após digitar ou ler o código
                      </span>
                    </div>
                  </div>

                  {[...produtos].reverse().map((produto, index) => {
                    const originalIndex = produtos.length - 1 - index;
                    return (
                      <>
                        {isLoading ? (
                          <Spin />
                        ) : (

                          <div
                            className={`cardT ${produto.travado ? 'travado' : ''}`}
                            onClick={() => {
                              if (!produto.travado) openModalItem({ ...produto, index: originalIndex });
                            }}
                            style={{ display: "flex", width: "100%" }}
                          >
                            {/* ESQUERDA - 60% */}
                            <div style={{ width: "60%" }}>
                              <span className="cardTextNome">{produto.nome}</span><br />
                              <span className="cardText">{`${produto.ean}`}</span><br />
                              <span className="cardText">
                                {`${formatarQuantidade(produto.quantidade)} ${produto.unidade || 'UN'} X ${produto.preco.toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )} = ${(produto.quantidade * produto.preco).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )} - ${parseFloat(produto.valorDesconto).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )} + ${parseFloat(produto.valorAcrescimo).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )} = ${(
                                  parseFloat(produto.quantidade) *
                                  parseFloat(produto.preco) -
                                  parseFloat(produto.valorDesconto) +
                                  parseFloat(produto.valorAcrescimo)
                                ).toLocaleString('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}`}
                              </span>
                            </div>

                            {/* DIREITA - 40% */}
                            <div style={{ width: "40%", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                              <span className="cardText">
                                {produto.observacao || <i style={{ color: "#aaa" }}>Sem observação</i>}
                              </span>
                            </div>
                          </div>



                        )}


                      </>
                    );
                  })}
                </div>
              )
            )}
    </div >
  );
};

export default Orcamentos;
